const getCustomerSegment = (win = window) => {
  const el = win.document.querySelector("[data-user-type]");
  switch (el && el.getAttribute("data-user-type")) {
    case "RETAIL_USER":
      return "Retail";
    case "ANONYMOUS_USER":
      return "Anonymous";
    case "UNLINKED_TRADE_USER":
      return "Retail";
    case "MAX_USER":
      return "Max";
    default:
      return "Max";
  }
};

export default getCustomerSegment;
